import { type V2Bag, type V2Value } from "@/features/applications/api/applications.api";
import { type FieldDef } from "../model";
import { FieldGrid } from "../FieldGrid";

export function ConfigStep({
  fields, bag, onChange,
}: {
  fields: FieldDef[];
  bag: V2Bag;
  onChange: (key: string, value: V2Value) => void;
}) {
  return (
    <div>
      <p className="text-sm text-slate-500 mb-6">
        Choose the lead source, which addenda apply, and whether the merchant will eSign.
      </p>
      <FieldGrid fields={fields} bag={bag} onChange={onChange} />
    </div>
  );
}
